module.exports = __webpack_public_path__ + "img/DimitriKnorr_140x140_rund.95469765.jpg";